import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=3a035e6a&scoped=true&"
import script from "./SignatureCanvas.vue?vue&type=script&lang=js&"
export * from "./SignatureCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCanvas.vue?vue&type=style&index=0&id=3a035e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a035e6a",
  null
  
)

export default component.exports